import React from "react";
import RegistrationForm from "../components/RegistrationForm";


const RegistrationPage = () => {
  return (
    <div>
<RegistrationForm/>
    </div>
  );
};

export default RegistrationPage;
